import { html } from '@microsoft/fast-element';
import { staticallyCompose } from '@microsoft/fast-foundation';
import type { Header } from './header.js';

import logoColor from '/brand/logo-full-color.svg?raw';
import logoReverse from '/brand/logo-full-color-reverse.svg?raw';

export default html<Header>`
	<template role="banner">
		<visually-hidden>
			<h1>Translational Analytics & Statistics, LLC</h1>
		</visually-hidden>
		<div part="positioning-region">
			<a href="/" aria-label="Translational Analytics & Statistics, LLC">
				<span class="logo-color">
					${staticallyCompose(logoColor)}
				</span>
				<span class="logo-white">
					${staticallyCompose(logoReverse)}
				</span>
			</a>
			<nav>
				<slot></slot>
			</nav>
		</div>
		<div role="presentation" class="backdrop"></div>
	</template>
`;